<div
  intDateStateController
  [date]="_currentDate"
  [type]="type"
  (onSelect)="onSelect($event)"
>
  <div class="int-calendar">
    <int-year-selector>
      <int-month-selector>
        <int-day-selector
          [markWeekends]="markWeekends"
          [minDate]="minDate"
          [maxDate]="maxDate"
        ></int-day-selector>
      </int-month-selector>
    </int-year-selector>
  </div>
</div>



